module.exports = __webpack_public_path__ + "img/gllogo.67f6f3e7.png";